import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '~/config';
import { handleNetworkError, withVersionHeaders } from '~/modules/utilities/axiosUtilities';
export function retrievePricing(listingId) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/pricing/pricing_plan/${listingId}`;
  return axios.get(url, {
    ...withVersionHeaders(),
    validateStatus: function (status) {
      // If we get a 404 don't treat it like an error
      return status < 400 || status === 404;
    }
  }).then(({
    data
  }) => data);
}
export function savePricing(record, isDraft = true, syncPrices = false, isSubmitForApproval = false) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/pricing/pricing_plan?public=${!isDraft}&syncPricing=${syncPrices}&approvalSubmit=${isSubmitForApproval}`;
  return axios.post(url, record, withVersionHeaders()).then(({
    data
  }) => data);
}
export function validatePricing(pricing) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/validate/pricing_plan`;
  return axios.post(url, pricing, withVersionHeaders()).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getEncryptedStateUrl() {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/pricing/encrypt`;
  return axios.post(url).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getPublisherAccountDetails() {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/pricing/publisher/account/`;
  return axios.get(url).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function validateVATNumber(vatNumber) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/streams/validateVat/?vatNumber=${vatNumber}`;
  return axios.get(url).then(({
    data
  }) => data).catch(handleNetworkError);
}